module.exports = __webpack_public_path__ + "static/media/grid-more.63c498e3.svg";